import useAuth from "hooks/useAuth";
import React, {
  createContext, useEffect, useMemo, useState,
} from "react";
import { toast } from "react-toastify";
import AxiosService from "services/Axios";

const PointsAndBalanceContext = createContext();

const PointsAndBalanceProvider = ({ children }) => {
  const [balancePoints, setBalancePoints] = useState(0);
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (isLoggedIn()) {
      getBalancePoints();
    }
  }, [isLoggedIn]);

  const getBalancePoints = async () => {
    try {
      const response = await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/points`);
      if (response?.data?.responseObject) {
        setBalancePoints(response?.data?.responseObject);
      }
      return response?.data?.responseObject ?? 0;
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
      return null;
    }
  };

  const getPointsUsageHistory = async () => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/points-usage-history`);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
      return null;
    }
  };

  const checkPointsStatus = async (testType) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/report-check/${testType}`);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
      return null;
    }
  };

  const getExtendedDailyFortunePoints = async (testType) => {
    try {
      return await AxiosService.get(`${process.env.REACT_APP_API_URL}/user/extended-daily-fortune/report-price/${testType}`);
    } catch (error) {
      toast.error("데이터를 불러오는데 오류가 발생했습니다.", error);
      return null;
    }
  };

  const value = useMemo(
    () => ({
      getBalancePoints,
      getPointsUsageHistory,
      checkPointsStatus,
      balancePoints,
      getExtendedDailyFortunePoints,
    }),
    [balancePoints],
  );

  return (
    <PointsAndBalanceContext.Provider value={value}>
      {children}
    </PointsAndBalanceContext.Provider>
  );
};

export { PointsAndBalanceContext, PointsAndBalanceProvider };
